import { FlagTriangleRight } from "lucide-react"
import { Badge } from "../atoms/Badge"
import { cn } from "../utils"

type Props = {
  issuesCount: number
  frictionsCount: number
  className?: string
}

export const FlagsBadge = ({ issuesCount, frictionsCount, className }: Props) => {
  return (
    <Badge
      variant="outline"
      className={cn("shrink-0 whitespace-nowrap px-1.5 text-xs font-medium", className)}
    >
      {issuesCount > 0 && (
        <div className="inline-flex items-center gap-0 text-testing-2 font-semibold">
          {issuesCount}
          <FlagTriangleRight className="!size-3" strokeWidth={3} />
        </div>
      )}
      {frictionsCount > 0 && (
        <div className="inline-flex items-center gap-0 text-negative-soft">
          {frictionsCount}
          <FlagTriangleRight className="!size-3" strokeWidth={2.5} />
        </div>
      )}
    </Badge>
  )
}
